<template>
  <v-container class="vertical-center" fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4 lg4 v-if="!recovered && !record.recoverPassKey">
        <v-card class="elevation-8 pa-3">
          <v-card-text>
            <div class="layout column align-center">
              <v-img src="@/assets/images/Blu.png" alt="Blú Capital" width="180" height="180"/>
              <h2 class="flex my-4 primary--text text-center font-weight-black text-uppercase">
                Recupera tu contraseña
              </h2>
            </div>
            <v-form
              ref="formRecover"
              v-model="isValid"
              lazy-validation
            >
              <v-text-field
                label="Correo Electrónico"
                name="username"
                v-model="record.email"
                prepend-icon="mdi-email"
                placeholder="Ingresa tu correo electrónico"
                type="text"
                :rules="emailRules"
                required
              />
            </v-form>
          </v-card-text>
          <v-card-text>
            <v-btn class="font-weight-black" block rounded color="#5B9DF2" dark @click="recoverPassword()">Recuperar contraseña</v-btn>
          </v-card-text>
          <v-card-actions>
            <h4 class="primary--text">¿Ya tienes cuenta? <a href="#" @click="goToLogin()">Inicia Sesión</a> </h4>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12 sm8 md4 lg4 v-if="recovered && !record.recoverPassKey">
        <v-card class="elevation-0 pa-3">
          <v-card-text>
            <div class="layout column align-center">
              <v-img src="@/assets/images/Blu.png" alt="Blú Capital" width="180" height="180"/>
              <h1 class="flex my-4 accent--text text-center">Recupera tu contraseña</h1>
              <h2 class="flex my-4 accent--text text-center">
              Hemos enviado un correo electronico a {{record.email}} con las instrucciones para recuperar tu contraseña.</h2>
              <v-btn rounded color="#5B9DF2" dark to="/login">Volver</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <ChangePassword
        v-if="record.recoverPassKey && !newPasswordSaved"
        :userKey="this.record.recoverPassKey"
        :email="this.record.email"/>
    </v-layout>
  </v-container>
</template>

<script>
import SessionService from '@/services/SessionService'
import ChangePassword from '@/components/Profile/ChangePassword.vue'
export default {
  name: 'RecoverPassword',
  components: { ChangePassword },
  async beforeCreate () {
    this.$store.dispatch('setUser', {
      isLoggedIn: false,
      user: {}
    })
  },
  async mounted () {
    if (this.$route.query.k && this.$route.query.e) {
      const loader = this.$loading.show()
      const recoveryData = {
        email: this.$route.query.e,
        key: this.$route.query.k
      }
      try {
        await SessionService.checkRecoveryKey(recoveryData)
        this.record.recoverPassKey = this.$route.query.k
        this.record.email = this.$route.query.e
        loader.hide()
      } catch (error) {
        loader.hide()
        console.error(error)
        this.showErrorMessage(error.response?.data?.message || error.message)
      }
    }
  },
  data () {
    return {
      recovered: false,
      newPasswordSaved: false,
      isValid: true,
      record: {
        email: '',
        password: '',
        password2: ''
      },
      emailRules: [
        v => !!v || 'El email es requerido',
        v => /.+@.+\..+/.test(v) || 'Ingresa un email válido (Ejemplo: correo@miempresa.com)',
        v => (v || '').indexOf(' ') < 0 || 'Los espacios no están permitidos'
      ],
      passwordRules: [
        v => !!v || 'La contraseña es requerida',
        v => (v || '').indexOf(' ') < 0 || 'Los espacios no están permitidos',
        v => (!!v && v) === this.record.password || 'Las contraseñas no coinciden',
        v => (v && v.length > 7) || 'La contraseña debe tener mínimo 8 caracteres'
      ]
    }
  },
  methods: {
    validateEmail () {
      this.isValid = false
      if (this.$refs.formRecover.validate()) {
        this.isValid = true
      }
    },
    validatePassword () {
      this.isValid = false
      if (this.$refs.formNewPassword.validate()) {
        this.isValid = true
      }
    },
    async recoverPassword () {
      await this.validateEmail()
      if (this.isValid) {
        const loader = this.$loading.show()
        try {
          await SessionService.recoverPassword(this.record)
          loader.hide()
          this.recovered = true
        } catch (error) {
          loader.hide()
          console.error(error)
          this.showErrorMessage(error.response?.data?.message || error.message)
        }
      }
    },
    async setNewPassword () {
      await this.validatePassword()
      if (this.isValid) {
        const loader = this.$loading.show()
        try {
          await SessionService.setNewPassword(this.record)
          loader.hide()
          this.newPasswordSaved = true
        } catch (error) {
          loader.hide()
          this.showErrorMessage(error.response?.data?.message || error.message)
        }
      }
    },
    showErrorMessage (message) {
      this.$swal({
        title: '¡Error!',
        html: this.$t(message),
        icon: 'error',
        showCancelButton: false,
        confirmButtonText: 'Ok',
        confirmButtonColor: '#1374F2',
        showCloseButton: true,
        allowOutsideClick: false
      })
    },
    goToLogin () {
      this.$router.push('/login')
    }
  }
}
</script>
<style scooped>
  .v-application .v-form .error--text {
    color: #df0000 !important;
    caret-color: #df0000 !important;
  }
</style>
